import styled from 'styled-components';

import SearchIcon from 'svg/SearchIcon';

type CoordinateEmptyProps = {
  message: string;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
};

const CoordinateEmpty = ({ style, message, icon = <SearchIcon width={32} height={32} /> }: CoordinateEmptyProps) => {
  return (
    <Container style={style}>
      <IconWrapper>{icon}</IconWrapper>
      <Message>{message}</Message>
    </Container>
  );
};

export default CoordinateEmpty;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
  flex: 1;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.black50};
`;

const Message = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.black50};
  margin: 0;
  text-align: center;
`;
